<mat-toolbar *ngIf="estadoInit" style="position: absolute; z-index: 2">
  <mat-toolbar-row>
    <button type="button" mat-button>
      <mat-icon
        *ngIf="!isDrawerVisible"
        style="color: white"
        (click)="openDrawer()"
      >
        menu
      </mat-icon>
      <mat-icon
        *ngIf="isDrawerVisible"
        style="color: white"
        (click)="closeDrawer()"
      >
        close
      </mat-icon>
    </button>
    <a class="nav-top-bar-logo-link" [routerLink]="'/home'">
      <img src="{{ imgLogo }}" alt="logoExplorandes" />
    </a>

    <div class="nav-bar-op-cont">
      <div class="container-bell-contador">
        <div
          class="container-puls"
          [matMenuTriggerFor]="menuNotificaciones"
          #menuTrigger="matMenuTrigger"
        >
          <div *ngIf="notificacionesNoLeidas.length > 0" class="bg"></div>
          <div class="button-puls">
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="27"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="icon icon-tabler icons-tabler-outline icon-tabler-bell"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path
                  d="M10 5a2 2 0 1 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6"
                />
                <path d="M9 17v1a3 3 0 0 0 6 0v-1" />
              </svg>
            </div>
          </div>
        </div>
        <div *ngIf="notificacionesNoLeidas.length > 0" class="contador-notis">
          {{ notificacionesNoLeidas.length }}
        </div>
      </div>

      <a
        class="salir-btn"
        (click)="signOut()"
        style="display: flex; justify-content: space-around"
        >SALIR
        <div class="separador"></div>
        <mat-icon style="margin: auto">exit_to_app</mat-icon></a
      >
    </div>
  </mat-toolbar-row>
</mat-toolbar>

<mat-menu
  #menuNotificaciones="matMenu"
  class="custom-menu mat-elevation-z8"
  [overlapTrigger]="false"
  [hasBackdrop]="false"
>
  <div class="notificaciones-container" (click)="$event.stopPropagation()">
    <div style="width: 100%" class="Notificacion-title-cont">
      <h2 mat-dialog-title style="font-size: 18px">Notificaciones</h2>
      <div style="cursor: pointer" (click)="closeMenu()">
        <mat-icon>
          <i-tabler
            name="x"
            style="width: 16px; height: 16px; font-size: 16px"
          ></i-tabler>
        </mat-icon>
      </div>
    </div>

    <mat-tab-group
      *ngIf="listaNotificaciones.length > 0"
      class="custom-tab-group"
      style="height: 100%"
      mat-stretch-tabs="false"
      animationDuration="0ms"
      (selectedTabChange)="onTabChange($event)"
    >
      <mat-tab>
        <ng-template mat-tab-label>
          <div class="d-flex align-items-center">
            <mat-icon>
              <i-tabler
                name="mail"
                style="width: 20px; height: 20px; font-size: 20px"
              ></i-tabler>
            </mat-icon>
          </div>
          <div class="separador"></div>
          No leídos
          <div class="separador"></div>
          <div class="contador">{{ this.notificacionesNoLeidas.length }}</div>
        </ng-template>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <div class="d-flex align-items-center">
            <mat-icon>
              <i-tabler
                name="mail-opened"
                style="width: 20px; height: 20px; font-size: 20px"
              ></i-tabler>
            </mat-icon>
          </div>
          <div class="separador"></div>
          Leídos
          <div class="separador"></div>
          <div class="contador">{{ this.notificacionesLeidas.length }}</div>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
    <mat-card-content
      [style.display]="tab !== 'noRead' ? 'none' : 'block'"
      style="height: 100%; min-height: 200px"
    >
      <div
        class="lista-notificaciones-container"
        *ngIf="notificacionesNoLeidas.length > 0"
      >
        <div *ngFor="let noti of notificacionesNoLeidas; let i = index">
          <app-notificaciones [data]="noti"></app-notificaciones>
        </div>
      </div>
      <div *ngIf="notificacionesNoLeidas.length === 0" class="Empty-noti-cont">
        <mat-icon class="rotated-bell-icon">
          <i-tabler
            name="bell-ringing"
            style="width: 100px; height: 100px"
          ></i-tabler>
        </mat-icon>
        <div style="font-size: 14px">
          No tienes notificaciones por ahora. ¡Estás al día! 🎉
        </div>
      </div>
    </mat-card-content>

    <mat-card-content
      [style.display]="tab !== 'read' ? 'none' : 'block'"
      class="p-y-24 b-t-1"
      style="height: 100%; min-height: 200px"
    >
      <div
        class="lista-notificaciones-container"
        *ngIf="notificacionesLeidas.length > 0"
      >
        <div *ngFor="let noti of notificacionesLeidas; let i = index">
          <app-notificaciones [data]="noti"></app-notificaciones>
        </div>
      </div>
      <div *ngIf="notificacionesLeidas.length === 0" class="Empty-noti-cont">
        <mat-icon class="rotated-bell-icon">
          <i-tabler
            name="bell-ringing"
            style="width: 100px; height: 100px"
          ></i-tabler>
        </mat-icon>
        <div style="font-size: 14px">
          No tienes notificaciones por ahora. ¡Estás al día! 🎉
        </div>
      </div>
    </mat-card-content>

    <div *ngIf="listaNotificaciones.length === 0" class="Empty-noti-cont">
      <mat-icon class="rotated-bell-icon">
        <i-tabler
          name="bell-ringing"
          style="width: 100px; height: 100px"
        ></i-tabler>
      </mat-icon>
      <div style="font-size: 14px">
        No tienes notificaciones por ahora. ¡Estás al día! 🎉
      </div>
    </div>
  </div>
</mat-menu>

<mat-drawer-container class="example-container" style="height: 100vh">
  <mat-drawer
    style="margin-top: 4rem"
    #drawer
    [(opened)]="isDrawerVisible"
    class="example-sidenav"
    *ngIf="isDrawerVisible"
  >
    <mat-nav-list *ngFor="let item of menuData">
      <span>
        <mat-icon class="material-symbols-rounded color-icon">{{
          item.icon
        }}</mat-icon>
        <span class="title-menu text-menu-color color-icon">{{
          item.menu
        }}</span>
        <hr />
      </span>
      <ng-container *ngIf="item.menu === 'TARIFARIO'; else internalMenu">
        <a
          mat-list-item
          class="sub-menu"
          href="{{ this.sourcingTarifa }}"
          target="_blank"
        >
          <mat-icon class="color-icon">{{ item.subMenu[0].icon }}</mat-icon>
          <span class="text-menu-color">{{ item.subMenu[0].name }}</span>
        </a>
      </ng-container>
      <ng-template #internalMenu>
        <a
          *ngFor="let sub of item.subMenu"
          mat-list-item
          class="sub-menu"
          [routerLink]="sub.route"
          (click)="closeDrawer()"
        >
          <mat-icon class="color-icon">{{ sub.icon }}</mat-icon>
          <span class="text-menu-color">{{ sub.name }}</span>
        </a>
      </ng-template>
    </mat-nav-list>
  </mat-drawer>

  <router-outlet></router-outlet>
</mat-drawer-container>
